import { dataReportSearchSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportSearchSolid = /*#__PURE__*/createIcon(dataReportSearchSolid)
export default IconReportSearchSolid
